






helpers = require('../../../helpers.coffee')

view_model =
  data: ->
    user: Session.current_user
    company: null

  components:
    companiesAutocomplete: require('../autocomplete/companies')

  methods:
    selectedCompany: (company) ->
      if @user.isAdmin()
        @setAdminCompany(company)
      else
        @getProperUser(company)

    getProperUser: (company) ->
      @company = company
      @users_resource.searchAccount @loadUserSuccess, @unknownError, params: { company_id: company.id }

    loadUserSuccess: (resource) ->
      @setUserCompany(resource.user) if resource

    setUserCompany: (user) ->
      Session.current_company = @company
      Session.current_user = user
      @$emit 'update-user'

      Session.setHttpHeaders()
      Session.saveSessionInfo(user)

      @resetStorage()

      if (@$router.currentRoute.path == '/contatos/leads')
        @goTo('/tarefas')
      else
        @goTo('/contatos/leads')

    setAdminCompany: (company) ->
      Session.current_company.id   = company.id
      Session.current_company.name = company.name

      @resetStorage()

      @goTo('/tarefas')

    resetStorage: ->
      @$store.commit 'resetUsers'
      @$store.commit 'resetTemplateCategories'
      @$store.commit 'resetTags'

  created: ->
    @users_resource = new UsersResource()


exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/header_actions/change_account.vue